export default __webpack_public_path__ + "static/stockies-9a4450a2eaab1dee987bc09e24d6b7e2.png";